export default function Pagination({ currentPage, totalPages, onPageChange, totalItems, pageSize }) {
  if (totalPages <= 1) return null;

  const from = (currentPage - 1) * pageSize + 1;
  const to   = Math.min(currentPage * pageSize, totalItems);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 0', userSelect: 'none' }}>
      <span style={{ fontSize: 12, color: 'var(--text-3)' }}>
        Showing {from}–{to} of {totalItems}
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={{ padding: '4px 12px', background: 'var(--navy-3)', border: '1px solid var(--border)', borderRadius: 6, color: currentPage === 1 ? 'var(--text-3)' : 'var(--text-1)', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', fontSize: 12 }}
        >
          ‹ Previous
        </button>
        <span style={{ fontSize: 12, color: 'var(--text-2)', minWidth: 80, textAlign: 'center' }}>
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{ padding: '4px 12px', background: 'var(--navy-3)', border: '1px solid var(--border)', borderRadius: 6, color: currentPage === totalPages ? 'var(--text-3)' : 'var(--text-1)', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', fontSize: 12 }}
        >
          Next ›
        </button>
      </div>
    </div>
  );
}
